import React from 'react';
import F1 from '../images/F1.png'
import F2 from '../images/F2.png'
import F3 from '../images/F3.png'
import F4 from '../images/F4.png'

const featureItems = [
  {
    // icon: <MessageSquare size={36} style={{ color: '#8B4513' }} />,
    icon: <img src={F1} alt="" style={{height:"50px"}}/>,
    title: 'Smooth Flavor',
    description: 'Delicately balanced with naturally sweet notes—every sip is a gentle embrace for the palate.'
  },
  {
    icon: <img src={F2} alt="" style={{height:"50px"}}/>,
    title: 'Lower Caffeine',
    description: 'Enjoy your coffee without the jitters—perfect for calm mornings and cozy evenings.'
  },
  {
    icon: <img src={F3} alt="" style={{height:"50px",width:"50px"}}/>,
    title: 'Grown at Higher Altitudes',
    description: 'Cultivated in the cool, misty hills of Araku Valley for richer aroma and refined taste.'
  },
  {
    icon: <img src={F4} alt="" style={{height:"50px",width:"50px"}}/>,
    title: 'AA Grade Arabica Beans',
    description: 'Only the finest, handpicked beans—graded AA for their size, shape, and exceptional quality.'
  }
];

const Features = () => {
  return (
    <section style={{
      padding: '0 20px 50px 20px',
      backgroundColor: '#accac1',
      position: 'relative',
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: 'url("https://images.pexels.com/photos/5699514/pexels-photo-5699514.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2")',
        backgroundSize: 'cover',
        opacity: 0.05,
        filter: 'sepia(70%)',
      }}></div>
      
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        position: 'relative',
        zIndex: 2,
      }}>
        <div style={{
          textAlign: 'center',
          marginBottom: '70px',
        }}>
          <h2 style={{
            fontFamily: '"Playfair Display", serif',
            fontSize: 'clamp(2rem, 4vw, 2.5rem)',
            color: '#5D4037',
            marginBottom: '16px',
            position: 'relative',
            display: 'inline-block',
          }}>
            Features of Bharat Araku Beans
            <span style={{
              position: 'absolute',
              bottom: '-10px',
              left: '50%',
              transform: 'translateX(-50%)',
              height: '3px',
              width: '80px',
              backgroundColor: '#D2691E',
              borderRadius: '3px',
            }}></span>
          </h2>
          <p style={{
            fontFamily: '"Source Sans Pro", sans-serif',
            fontSize: 'clamp(1rem, 2vw, 1.1rem)',
            color: '#6B4226',
            maxWidth: '700px',
            margin: '0 auto',
            lineHeight: 1.6,
          }}>
          
          </p>
        </div>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(1, 1fr)',
          gap: '30px',
          '@media (min-width: 768px)': {
            gridTemplateColumns: 'repeat(2, 1fr)',
          },
          '@media (min-width: 1024px)': {
            gridTemplateColumns: 'repeat(4, 1fr)',
          },
        }} className="md:grid-cols-2 lg:grid-cols-4">
          {featureItems.map((feature, index) => (
            <div key={index} style={{
              backgroundColor: 'rgba(255, 248, 225, 0.7)',
              backdropFilter: 'blur(5px)',
              borderRadius: '12px',
              padding: '30px',
              boxShadow: '0 6px 15px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(210, 105, 30, 0.1)',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              ':hover': {
                transform: 'translateY(-5px)',
                boxShadow: '0 12px 20px rgba(0, 0, 0, 0.1)',
              },
            }}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
              }}>
                <div style={{
                  marginBottom: '20px',
                  padding: '15px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(210, 105, 30, 0.1)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                  {feature.icon}
                </div>
                <h3 style={{
                  fontFamily: '"Playfair Display", serif',
                  fontSize: '1.3rem',
                  color: '#5D4037',
                  marginBottom: '12px',
                  fontWeight: 600,
                }}>
                  {feature.title}
                </h3>
                <p style={{
                  fontFamily: '"Source Sans Pro", sans-serif',
                  fontSize: '1rem',
                  color: '#6B4226',
                  lineHeight: 1.5,
                }}>
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;